module.exports = __webpack_public_path__ + "static/media/right-move.fcd41b5a.svg";